// Serial-number capture helpers for Receive Goods (SERIAL-tracked lines).
// Mirrors the API rules in services/api/src/common/utils/inventory-tracking.ts:
// one serial per unit, unique (case-insensitive), whole units only.

/** Split pasted / scanned text into trimmed serials — newline, comma, semicolon or whitespace separated. */
export function parseSerials(text: string): string[] {
  return text
    .split(/[\n,;\s]+/)
    .map((s) => s.trim())
    .filter(Boolean);
}

/** Case-insensitive duplicates within one line's serials. */
export function duplicateSerials(serials: string[]): string[] {
  const seen = new Set<string>();
  const dups = new Set<string>();
  for (const s of serials) {
    const key = s.toUpperCase();
    if (seen.has(key)) dups.add(s);
    seen.add(key);
  }
  return [...dups];
}

/** Validation message for a SERIAL line, or null when it can be submitted. */
export function serialError(serials: string[], quantity: number): string | null {
  if (!(quantity > 0)) return null;
  if (!Number.isInteger(quantity)) return 'Serial-tracked items must be received in whole units';
  const dups = duplicateSerials(serials);
  if (dups.length > 0) return `Duplicate serial: ${dups[0]}`;
  if (serials.length !== quantity) {
    return `Enter one serial number per unit (${serials.length} / ${quantity} entered)`;
  }
  return null;
}
